import { colorTheme } from './extendedColors';
import { radiiTheme } from './extendedRadii';
import { spacingTheme } from './extendedSpacing';
import { pxToRem } from './biomeTokens';

export const popperContent = {
  'z-Index': '55'
};

export const popoverContent = {
  borderRadius: radiiTheme[3],
  boxShadow: 'l5',
  borderColor: colorTheme.foundation[300],
  '--popper-arrow-shadow-color': colorTheme.foundation[300]
};

export const popoverBody = {
  px: spacingTheme[20],
  py: spacingTheme[20]
};

export const popoverVariantTime = {
  content: {
    w: pxToRem(250)
  }
};

export const popoverTheme = {
  baseStyle: {
    popper: popperContent,
    content: popoverContent,
    body: popoverBody
  },
  variants: {
    time: popoverVariantTime
  }
};
